import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SiteuserService} from '../services/siteuser.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  uname:string;
  sajid:string;
  isloggedin:boolean;

  constructor(private usrObj:SiteuserService, private router:Router,public translate: TranslateService) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|ar/) ? browserLang : 'en');
   }

  ngOnInit(): void {

    if(this.usrObj.loggedIn() == false){
      this.isloggedin = false;
    }else{
      this.isloggedin = true;
    }

  }

}
